import axios from "axios";
import { del, get, post, patch,  put } from "./mentions_api_helper";
import * as url from "./mentions_url_helper";





// Get features
export const getMentions = () => get(url.GET_MENTIONS);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewMention = mention => post(url.ADD_NEW_MENTION, mention);



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateMention = mention => patch(`${url.UPDATE_MENTION}/${mention.id}`,  mention);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteMention = mention => del(`${url.DELETE_MENTION}/${mention.id}`);







export {
  //getLoggedInUser,
  
  
};
